/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between compound interest and a SIP?`)
};

const es_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre interés compuesto y un SIP?`)
};

const de_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen Zinseszins und einem SIP?`)
};

const nl_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen samengestelde rente en SIP?`)
};

const fr_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre les intérêts composés et un SIP ?`)
};

const it_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra interesse composto e un SIP?`)
};

const pt_br2_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre juros compostos e um SIP?`)
};

const pt_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre juro composto e um SIP?`)
};

const ja_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利とSIPの違いは何ですか？`)
};

const zh_sip_compound_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复利和SIP之间有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_compound_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_compound_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_compound_faq3_q", locale)
	if (locale === "en") return en_sip_compound_faq3_q(inputs)
	if (locale === "es") return es_sip_compound_faq3_q(inputs)
	if (locale === "de") return de_sip_compound_faq3_q(inputs)
	if (locale === "nl") return nl_sip_compound_faq3_q(inputs)
	if (locale === "fr") return fr_sip_compound_faq3_q(inputs)
	if (locale === "it") return it_sip_compound_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_compound_faq3_q(inputs)
	if (locale === "pt") return pt_sip_compound_faq3_q(inputs)
	if (locale === "ja") return ja_sip_compound_faq3_q(inputs)
	return zh_sip_compound_faq3_q(inputs)
};